module.exports = __webpack_public_path__ + "img/closee.3c6e8776.svg";